export const DEFAULT_META_TITLE = 'Аптека Bosco'
export const DEFAULT_META_DESCRIPTION = 'Аптека Bosco'
